import React, { forwardRef, memo } from 'react'

const MegaphoneIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="105"
      height="99.4"
      viewBox="0 0 105 99.4"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M86.6628 65.5442C89.7612 57.9065 90.5457 49.2566 88.3792 40.6548C82.9395 19.0536 60.9502 5.93519 39.2648 11.3339C17.5794 16.7326 4.40988 38.6766 9.8498 60.2778C15.2897 81.8791 37.2791 94.9975 58.9645 89.5987L102.583 78.68C104.167 78.2838 104.476 76.1712 103.072 75.3347L86.6628 65.5442Z"
        fill="#DA291C"
      />
      <path
        d="M37.2223 21.5968C37.1122 20.9854 37.5315 20.4054 38.1464 20.3183L51.3659 18.4468C51.977 18.3599 52.5783 18.7949 52.6101 19.4081L57.5002 62.0028C57.5309 62.5727 57.1118 63.0988 56.5478 63.178L46.0557 64.68C45.4977 64.7587 44.9731 64.3785 44.8219 63.788L37.2223 21.5968Z"
        fill="black"
      />
      <rect
        width="12.328"
        height="12.282"
        rx="1.096"
        transform="matrix(0.990126 -0.140182 0.141256 0.989973 45.472 68.0702)"
        fill="black"
      />
      <path
        d="M39.8667 18.9629C39.7565 18.3515 40.1758 17.7715 40.7908 17.6844L54.0103 15.8129C54.6213 15.726 55.2226 16.161 55.2544 16.7742L60.1445 59.3689C60.1752 59.9388 59.7561 60.4649 59.1921 60.5441L48.7 62.046C48.142 62.1247 47.6174 61.7445 47.4662 61.154L39.8667 18.9629Z"
        fill="white"
      />
      <rect
        width="12.328"
        height="12.282"
        rx="1.096"
        transform="matrix(0.990126 -0.140182 0.141256 0.989973 48.1158 65.4357)"
        fill="white"
      />
    </svg>
  )
)

MegaphoneIcon.displayName = 'MegaphoneIcon'

export default memo(MegaphoneIcon)
